var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFigoCardLogo(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Figo"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Fill-19",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.0051 2.00011H11.9975H11.9873C6.94893 1.9886 3.48492 2.86115 3 2.97738V3.25537V9.22016C3 11.5398 3.8641 13.6378 3.8641 13.6378C5.54782 18.0415 11.5622 21.6783 11.9873 21.9876V22H11.9975H12.0051V21.9876C12.4378 21.6783 18.4598 18.0415 20.1473 13.6378C20.1473 13.6378 21 11.5398 21 9.22016V3.25537V2.97738C20.5203 2.86115 17.0497 1.9886 12.0051 2.00011ZM17.0429 7.03048C14.6109 6.95606 12.1757 6.94121 9.74232 6.9856V10.1715C11.6761 10.1679 13.6113 10.1681 15.5451 10.1721V11.7082C13.6113 11.7212 11.6759 11.7219 9.74232 11.7104V15.6362C9.12968 15.6202 8.51722 15.5987 7.90475 15.5721V5.51091C10.9493 5.37757 13.9986 5.37757 17.0429 5.51091V7.03048Z",
    fill: "#01313D"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFigoCardLogo);
export default __webpack_public_path__ + "static/media/figo-card-logo.1a0578dfaee7f443ccfc77a9a5676ffc.svg";
export { ForwardRef as ReactComponent };